import { getAxiosInstance } from "./axiosInstance";

const uploadInventory = (formData) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/inventory/upload/",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

const inventoryList = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/inventory/list/",
        data
    );
};

const deleteInventory = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/esimdata/delete/",
        data
    );
};

/* -------------------------------
   Bootstrap Activation APIs
-------------------------------- */

const bootstrapList = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/bootstrap/list/",
        data
    );
};

const exportBootstrap = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/bootstrap/export/",
        data,
        {
            responseType: "blob",
        }
    );
};

const uploadBootstrapResult = (formData) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/bootstrap/upload-result/",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

/* ---------------------------------------
   Commercial Activation APIs
--------------------------------------- */

const commercialList = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/commercial/list/",
        data
    );
};

const commercialCreate = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/commercial/create/",
        data
    );
};

const commercialExport = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/commercial/export/",
        data,
        {
            responseType: "blob",
        }
    );
};

const uploadCommercialResult = (formData) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/commercial/upload-result/",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

/* ---------------------------------------
   KYC Report APIs
--------------------------------------- */

const kycSummary = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/kyc/summary/",
        data
    );
};

const kycList = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/kyc/list/",
        data
    );
};

const kycDocument = (id) => {
    const http = getAxiosInstance();

    return http.get(
        `/api/stock/kyc/document/?id=${id}`,
        {
            responseType: "blob",
        }
    );
};

const exportKycExcel = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/kyc/export-excel/",
        data,
        {
            responseType: "blob",
        }
    );
};

const exportKycZip = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/kyc/export-zip/",
        data,
        {
            responseType: "blob",
        }
    );
};

/* ---------------------------------------
   Device Health API
--------------------------------------- */

const deviceHealth = () => {
    const http = getAxiosInstance();

    return http.get(
        "/api/public/dealer/mapwalaprecitrack/devices/data/"
    );
};

const rebootDevice = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/public/device-console/command/send/",
        data
    );
};

// Stock Master status overview
const stockMasterStatusOverview = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/master-status/overview/",
        data
    );
};

const InventoryServices = {
    uploadInventory,
    inventoryList,
    deleteInventory,

    bootstrapList,
    exportBootstrap,
    uploadBootstrapResult,

    // Commercial Activation
    commercialList,
    commercialCreate,
    commercialExport,
    uploadCommercialResult,

     // KYC Report
    kycSummary,
    kycList,
    kycDocument,
    exportKycExcel,
    exportKycZip,
    deviceHealth,
    rebootDevice,
    stockMasterStatusOverview,
};

export default InventoryServices;